import apiService from 'services/apiService';

const baseUrl = `${window._env_.MONITOR_API_DOMAIN}`;

const getCreditRiskCategories = () => {
  const url = `${baseUrl}/v1/credit-risks/categories`;
  return apiService.get(url);
};

export { getCreditRiskCategories };
